'use strict';

const SEARCH_ADDED = {
    category: 'search favoriting',
    action: 'search added'
};

const SEARCH_REMOVED = {
    category: 'search favoriting',
    action: 'search removed'
};

const DEALER_ADDED = {
    category: 'dealer favoriting',
    action: 'dealer added'
};

const DEALER_REMOVED = {
    category: 'dealer favoriting',
    action: 'dealer removed'
};

module.exports = {
    SEARCH: {
        TOP_OF_RESULTS: {
            save: Object.assign({label: 'top of results'}, SEARCH_ADDED),
            remove: Object.assign({label: 'top of results'}, SEARCH_REMOVED)
        },
        BROWSE_AUTH_MODAL: {
            ga: {
                label: 'save search - search/browse page'
            }
        },
        SOLD_PDP: {
            save: Object.assign({label: 'PDP-Sold'}, SEARCH_ADDED),
            remove: Object.assign({label: 'PDP-Sold'}, SEARCH_REMOVED)
        },
        SOLD_PDP_AUTH_MODAL: {
            ga: {
                label: 'save search - PDP-Sold'
            }
        }
    },
    DEALER: {
        MESSAGE_CENTER: {
            save: Object.assign({label: 'message center'}, DEALER_ADDED),
            remove: Object.assign({label: 'message center'}, DEALER_REMOVED)
        },
        SELLERS_PAGE: {
            save: Object.assign({label: 'sellers page'}, DEALER_ADDED),
            remove: Object.assign({label: 'sellers page'}, DEALER_REMOVED)
        },
        DEALER_STOREFRONT_AUTH_MODAL: {
            ga: {
                label: 'favorite dealer - dealer storefront'
            }
        },
        CONTACT_MODAL: {
            save: Object.assign({label: 'contact dealer confirmation modal'}, DEALER_ADDED),
            remove: Object.assign({label: 'contact dealer confirmation modal'}, DEALER_REMOVED)
        },
        PDP: {
            save: Object.assign({label: 'pdp'}, DEALER_ADDED),
            remove: Object.assign({label: 'pdp'}, DEALER_REMOVED)
        },
        PDP_AUTH_MODAL: {
            ga: {
                label: 'favorite dealer - product page'
            }
        }
    },
    DESIGNER: {
        PROFILE: {
            save: {
                category: 'trade firm favoriting',
                action: 'trade firm added',
                label: 'trade firm profile page'
            },
            remove: {
                category: 'trade firm favoriting',
                action: 'trade firm removed',
                label: 'trade firm profile page'
            }
        },
        AUTH_MODAL: {
            ga: {
                label: "follow trade firm"
            }
        }
    }
};



// WEBPACK FOOTER //
// ./assets/js/components/FavoriteCta/trackingData.es.js